import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addpayerLoading: false,
//   loadingNote_Types: false,

allservicecode: [],
allproccode:[],
alldiagnosisCode:[],
allproviderservices:[]
//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const servicecodeState = createSlice({
  name: "servicecode",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddPayerLoading(state, action) {
      return {
        ...state,
        addpayerLoading: action?.payload
      };
    },

    setAllServiceCode(state, action) {
        return {
          ...state,
          loading: false,
          allservicecode: action?.payload,
        //   addFacilityLoading: false
        };
      },

      

      
      setAllProcCode(state, action) {
      return {
        ...state,
        loading: false,
        allproccode: action?.payload,
      //   addFacilityLoading: false
      };
    },

    setAllProviderServices(state, action) {
      return {
        ...state,
        loading: false,
        allproviderservices: action?.payload,
      //   addFacilityLoading: false
      };
    },



    

    

    setAllDiagnosisCode(state, action) {
      return {
        ...state,
        loading: false,
        alldiagnosisCode: action?.payload,
      //   addFacilityLoading: false
      };
    },





    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddPayerLoading,
  setAllServiceCode,
  setAllProcCode,
  setAllProviderServices,
  setAllDiagnosisCode,
} = servicecodeState.actions;
export default servicecodeState.reducer;
